<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>教材报错</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px" @keyup.enter="search">
      <Form :label-width="100" label-position="left">
        <Row :gutter="32">
          <Col :span="6">
            <FormItem label="提交时间：">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                align="right"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onDateChange"
                size="small"
                style="width: 100%"
              >
              </el-date-picker>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="教材版本：">
              <Select v-model="queryParam.materialVersionId" @on-change="loadLevelIds" placeholder="请选择" clearable>
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="课程等级：">
              <Select v-model="queryParam.levelId" clearable @on-change="search">
                <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="老师ID：">
              <Input v-model="queryParam.tchId"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="老师姓名：">
              <Input v-model="queryParam.tchName"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="处理方式：">
              <Select v-model="queryParam.status" placeholder="请选择" @on-change="search" clearable>
                <Option v-for="item in $constant.lessonErrStatus" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="1">
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search">搜索
              </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookMaterialLessonsErr/list"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
    // import dateFormat from '@/tools/date/format.js'
    import dates from '@/tools/date/dates.js'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
    export default {
      name: 'BookMaterialLessonsErr',
      data () {
        let self = this
        let $constant = this.$constant
        return {
          searchLoading: false,
          reload: 0,
          rankScoreSeq: 0,
          dateRange: ['', ''],
          queryParam: {
            materialVersionId: null,
            startTime: null,
            endTime: null,
            levelId: null,
            tchId: null,
            status: ''
          },
          levels: [],
          title: [
            {
              title: '老师ID/姓名',
              // width: 150,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                return renderTchNameWithScore(h, {
                  text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
                  score: row.monthRankScore
                })
              }
            },
            {
              title: '课程标题',
              // width: 150,
              align: 'center',
              key: 'lesson'
            },
            {
              title: '等级',
              // width: 120,
              align: 'center',
              key: 'level'
            },
            {
              title: '版本',
              // width: 90,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                let materialVersion = $constant.getEnum($constant.materialVersions, row.materialVersion)
                return h('span', materialVersion && materialVersion.text)
              }
            },
            {
              title: '提交时间',
              width: 170,
              align: 'center',
              key: 'gmtCreate'
            },
            {
              title: '内容',
              width: 200,
              align: 'center',
              key: 'remark'
            },
            {
              title: '处理人',
              // width: 110,
              align: 'center',
              key: 'modifierName',
              render: (h, params) => {
                let row = params.row
                if (row.status === 0) {
                  return h('span', '')
                }
                return h('span', row.modifierName)
              }
            },
            {
              title: '处理时间',
              width: 170,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                if (row.status === 0) {
                  return h('span', '')
                }
                return h('span', row.gmtModified)
              }
            },
            {
              title: '处理方式',
              // width: 100,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                let status = $constant.getEnum($constant.lessonErrStatus, row.status)
                return h('span', status && status.text)
              }
            },
            {
              title: '操作',
              align: 'center',
              // width: 150,
              render: (h, params) => {
                let row = params.row
                if (row.status === 0) {
                  return h('div', [
                    h('a', {on: {click: () => { self.onEdit(row, 1) }}}, '已修改  '),
                    h('a', {on: {click: () => { self.onEdit(row, 2) }}}, '错误提交  '),
                  ])
                } else {
                  return h('span', '')
                }
              }
            }
          ]
        }
      },
      mounted: function () {
        let self = this
        let query = self.$route.query
        if (query) {
          if (query.materialVersionId) {
            self.queryParam.materialVersionId = parseInt(query.materialVersionId)
          }
          if (query.startTime) {
            self.dateRange[0] = dates.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
          if (query.endTime) {
            self.dateRange[1] = dates.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
          if (query.levelId) {
            self.queryParam.levelId = parseInt(query.levelId)
          }
          if (query.tchId) {
            self.queryParam.tchId = parseInt(query.tchId)
          }
          if (query.status) {
            self.queryParam.status = parseInt(query.status)
          }
        }
      },
      created: function () {
        let self = this
        let query = self.$route.query
        if (query) {
          if (query.startTime) {
            self.dateRange[0] = dates.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
          if (query.endTime) {
            self.dateRange[1] = dates.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
        }
        this.loadLevelIds()
      },
      methods: {
                onLoading (loading) {
          this.searchLoading = loading
          if (!loading) {
            this.loadMonthRankScores()
          }
        },
        loadMonthRankScores () {
          const table = this.$refs.dataList && this.$refs.dataList.tableData
          if (!table || !table.length) {
            return
          }
          const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
          const seq = ++this.rankScoreSeq
          const self = this
          fetchTchScoreMap(this.$http, ids).then(function (map) {
            if (seq !== self.rankScoreSeq) {
              return
            }
            applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
          })
        },
        loadLevelIds (val) {
          let self = this
          let url = '/bookMaterialLevel/listByCondition'
          if (val) {
            url = '/bookMaterialLevel/listByCondition?materialVersion=' + val
          }
          self.$http.get(url).then(res => {
            if (res && res.data) {
              self.levels = res.data
            }
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onEdit (row, status) {
          let self = this
          let path = '/bookMaterialLessonsErr/update?id=' + row.id + '&status=' + status
          self.$http.post(path, this.formData).then((res) => {
            if (res && res.data > 0) {
              self.$Message.success('审核成功!')
              self.search()
            }
          })
        },
        onDateChange (dateRange) {
          if (dateRange && dateRange.length === 2) {
            let beginTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime()
            this.queryParam.startTime = parseInt(beginTime / 1000)
            this.dateRange[0] = dates.format(beginTime, 'YYYY-MM-DD HH:mm:ss') + ''
            let endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
            this.queryParam.endTime = parseInt(endTime / 1000)
            this.dateRange[1] = dates.format(endTime, 'YYYY-MM-DD HH:mm:ss') + ''
          } else {
            this.dateRange = []
            this.queryParam.startTime = null
            this.queryParam.endTime = null
          }
          this.search()
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// BookMaterialLessonsErr.vue?4361ce40